import classNames from 'classnames';
import { useEffect, useState } from 'react';

import { Article, useCheckoutContext } from '@zooplus/checkout-state';
import ShopFooter, { getShopFooterProps, ShopFooterProps, Stage } from '@zooplus/shop-footer';

import { getAppConfig } from '@config/get-app-config';
import { useTranslation } from '@hooks/use-translations';
import { logError } from '@services/sentry-service';
import styles from '@styles/common.module.scss';
import { AREA_TITLE, CHECKOUT_STATE_PROJECT_ID, PAGE_TYPE } from '@utilities/constants';
import { getEnvType, isArrayNotEmpty } from '@utilities/utils';

import MinimalistFooter from './minimalist-footer';

const Footer = () => {
  const { site, environment } = getAppConfig();
  const { ready } = useTranslation();
  const {
    isFetching,
    checkoutState,
    mainTogglesMap = {},
    isStickyAutoshipmentPresent,
  } = useCheckoutContext(CHECKOUT_STATE_PROJECT_ID);
  const isNewOverviewPage = mainTogglesMap.CHECKOUT_FRONTEND_NEW_OVERVIEW_PAGE;
  const articles = checkoutState?.cart?.articles;

  const stickyButton = isNewOverviewPage && isArrayNotEmpty(articles as Article[]) && !isFetching;

  const [footerProps, setFooterProps] = useState<ShopFooterProps>();

  useEffect(() => {
    (async () => {
      try {
        setFooterProps(
          await getShopFooterProps({
            stage: getEnvType(environment) as Stage,
            app: AREA_TITLE,
            locale: site.locale,
            domain: site.domain,
          }),
        );
      } catch (err) {
        logError(err, {
          extra: {
            message: 'Shop-footer error in getShopFooterProps',
          },
        });
      }
    })();
  }, [environment, site.locale, site.domain]);

  if (!ready) {
    return <></>;
  }

  return window.location.href.includes(PAGE_TYPE.LOGIN_SELECTION) ? (
    <MinimalistFooter />
  ) : (
    <footer
      className={classNames(
        styles.footerWrapper,
        stickyButton
          ? isStickyAutoshipmentPresent
            ? styles.stickyAutoshipment
            : styles.stickyButton
          : '',
      )}>
      {footerProps && <ShopFooter {...footerProps} />}
    </footer>
  );
};

export default Footer;
